import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../utils/translations';
import ModifyBookingModal from '../ModifyBookingModal/ModifyBookingModal';
import ManageBookingSection from '../ManageBookingSection/ManageBookingSection';

const ModifyBooking = ({policyType, translations}) => (
    <Fragment>
        <ManageBookingSection data-testid="manage-booking-modify-booking">
            <div className="CancelSection__section-content-container CancelSection__section-content-container__change">
                <h3>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'modifyBooking.request.title'
                    )}
                </h3>
                <p className="CancelSection__section-content">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'tripDetails.modifyBooking.selfModification.description'
                    )}
                </p>
                <div className="CancelSection__section-content">
                    <ModifyBookingModal
                        buttonLabel={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'tripDetails.modifyBooking.selfModification.button'
                        )}
                        policyType={policyType}
                        translations={translations}
                    />
                </div>
            </div>
        </ManageBookingSection>
        <div className="change-section-separator" />
    </Fragment>
);

ModifyBooking.propTypes = {
    policyType: PropTypes.string,
    translations: PropTypes.shape({}),
};

export default ModifyBooking;
